import styled from 'styled-components';
import { Label } from '../../../components/uielements';
import { palette } from 'styled-theme';

export const Main = styled.main`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;
  width: 100vw;
`;

export const SectionLeft = styled.section`
  background-color: ${palette('background', 0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  padding: 120px;
`;

export const SectionRight = styled.section`
  background-image: url(${(props) => props.bg});
  transition: background-image 0.5s ease-in-out;
  background-size: cover;
  background-position: center;
`;

export const Heading = styled(Label).attrs({ size: 'header2', color: 'black', weight: 'bold' })`
  text-transform: uppercase;
`;

export const SubHeading = styled(Label).attrs({ size: 'small', color: 'black' })`
  font-family: 'Inter';
  line-height: 24px;
`;

export const LinksContainer = styled.div`
  display: flex;
  gap: 1.8rem;
`;

export const LinkButton = styled.a`
  color: ${palette('text', 1)};
  text-decoration: underline;
  cursor: pointer;
  font-family: 'Inter';
  font-size: 16px;
  text-underline-offset: 3px;
`;
